import { composites } from '../../../../common/constants/access';
import { getRequestLimitQuery } from '../../../queries/companyQuery';
import { selectedTeamIdQuery } from '../../../queries/teamQuery';
import { getVerifyUserAccessQuery, userQuery } from '../../../queries/userQuery';

import type { QueryClient } from '@tanstack/react-query';
export const teamsOverviewLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const teamIdQuery = selectedTeamIdQuery('selectedTeamID');
	const verifyUserAccessQuery = getVerifyUserAccessQuery((composites as any).VIEW_COMPANY_SETTINGS);
	const requestLimitQuery = getRequestLimitQuery();

	const teamId = await queryClient.ensureQueryData(teamIdQuery);

	const userData = await queryClient.ensureQueryData(userQuery);

	const hasAccess = await queryClient.ensureQueryData({
		queryKey: verifyUserAccessQuery.queryKey,
		queryFn: verifyUserAccessQuery.queryFn,
	});

	const requestLimitData = await queryClient.ensureQueryData({
		queryKey: requestLimitQuery.queryKey,
		queryFn: requestLimitQuery.queryFn,
	});

	return {
		teamId,
		userData,
		hasAccess,
		requestLimitData,
	};
};
